// @ts-nocheck
import * as React from "react";

const SaveLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="m20.12 8.71-4.83-4.83A3 3 0 0 0 13.17 3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7.17a3 3 0 0 0-.88-2.12ZM10 19v-2h4v2h-4Zm9-1a1 1 0 0 1-1 1h-2v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2v5a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-3V5h3.17c.265.004.518.107.71.29l4.83 4.83a1 1 0 0 1 .29.71V18Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(SaveLine);
